import {
  GithubSignInPrepResponse,
  GithubSignInCallbackRequest,
  MarketingInterestRequest,
  MarketingInterestResponse,
  AuthenticationState,
  GithubLoggedInRequest,
  GithubLoggedInResponse,
  GithubGistDetailRequest,
  GithubGistUpdateRequest, GoogleSignInPrepResponse, GoogleSignInCallbackRequest,
  GoogleLoggedInRequest, GoogleAccountInfoResponse, EmailManualSignInRequest, EmailManualSignInResponse,
  EmailManualSignUpResponse, EmailVerificationRequest, EmailVerificationResponse, PasswordResetRequest,
  PasswordResetResponse
} from '../utils/types';

import {
  DeleteTradingAlgoRequest, DeleteTradingAlgoResponse,
  GetTradingAlgosRequest, GetTradingAlgosResponse, PutTradingAlgosRequest, PutTradingAlgosResponse,
  StreamingResponseErrorDetail, StreamingResponseMessagePosition,
  TradingAlgorithmBacktestRequest, TradingBacktestResult,
  TradingAlgorithmBacktestStreamingResponse, StorableBacktestResultRequest, StorableBacktestResultResponse,
  GetBacktestHistoryRequest, GetBacktestHistoryResponse, TradingFeedbackRequest, TradingFeedbackResponse,
  CreateShareableBacktestLinkResponse, CreateShareableBacktestLinkRequest,
  GetSharedBacktestRequest, GetSharedBacktestResponse, GetPriceForTickerOnDateRequest, GetPriceForTickerOnDateResponse,
  StreamChatRequest, StreamChatRequestCore,
} from "../utils/typesTrading";

import {
  getJunkyardAPIHostname
} from '../utils/navigation'
import {GithubGist, SearchGithubGistResponse} from "../utils/typesGists";
import {
  DeleteAccountRequest, DeleteAccountResponse,
  StripeCancelSubscriptionsRequest, StripeCancelSubscriptionsResponse,
  StripeCreateCheckoutSessionRequest,
  StripeCreateCheckoutSessionResponse,
  StripeCreateCustomerRequest,
  StripeCreateCustomerResponse
} from "../utils/typesStripe";

export async function marketingInterest(props: MarketingInterestRequest): Promise<MarketingInterestResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/marketing/interest';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as MarketingInterestResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

export async function githubSignIn(): Promise<GithubSignInPrepResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/github/login';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as GithubSignInPrepResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}


export async function googleSignIn(): Promise<GoogleSignInPrepResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/google/login';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as GoogleSignInPrepResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}


export async function githubSignInCallback(props: GithubSignInCallbackRequest): Promise<AuthenticationState>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/github/access_token';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    console.debug("data", data)
    return data as AuthenticationState;
  } else {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}


export async function googleSignInCallback(props: GoogleSignInCallbackRequest): Promise<AuthenticationState>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/google/access_token';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    console.debug("data", data)
    return data as AuthenticationState;
  } else {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

export async function githubGetAccountDetails(props: GithubLoggedInRequest): Promise<GithubLoggedInResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/github/account';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as GithubLoggedInResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}`);
  }
}



export async function googleGetAccountDetails(props: GoogleLoggedInRequest): Promise<GoogleAccountInfoResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/google/account';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as GoogleAccountInfoResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}`);
  }
}


export async function githubGetGists(props: GithubLoggedInRequest): Promise<SearchGithubGistResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/gists/list';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as SearchGithubGistResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}`);
  }
}


export async function githubGistDetail(props: GithubGistDetailRequest): Promise<GithubGist>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/gists/detail';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data.data as GithubGist;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}`);
  }
}

export async function githubUpdateGist(props: GithubGistUpdateRequest): Promise<GithubGist>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/gists';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data.data as GithubGist;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}`);
  }
}


export async function emailSignIn(props: EmailManualSignInRequest): Promise<EmailManualSignInResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/email/login'
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  if (response.ok) {
    const data = await response.json();
    console.debug(data);
    return data as EmailManualSignInResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}`);
  }
}

export async function emailSignUp(props: EmailManualSignInRequest): Promise<EmailManualSignUpResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/email/sign_up'
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  if (response.ok) {
    const data = await response.json();
    console.debug(data);
    return data as EmailManualSignUpResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}`);
  }
}

async function* parseStreamedResponse<T = unknown>(response: Response): AsyncGenerator<T, any, unknown> {
  /*
  Note: function* declares a generator function.
  A generator function is special because it can pause and resume execution using yield statements
  It returns an iterator / generator object, not a direct value
  It produces a sequence of values, one at a time, lazily.

  Note: the generic <T> parameter allows this function to be reused with different message types while maintaining
  type safety.
   */
  const startByte = 0x00;
  const endByte = 0x01;
  let buffer: Uint8Array = new Uint8Array();

  const reader: ReadableStreamDefaultReader<Uint8Array> | undefined = await response.body?.getReader();
  if (!reader) {
    throw new Error('No response body');
  }

  while (true) {
    const { done, value } = await reader.read();

    if (value) {
      const newBuffer = new Uint8Array(buffer.length + (value?.length || 0))
      // copy existing data into newBuffer
      newBuffer.set(buffer);
      // copy new data in starting at the end of the existing buffer
      newBuffer.set(value, buffer.length);
      // now the buffer includes the new data
      buffer = newBuffer;
    }

    while (true) {

      // check for start and end magic bytes signaling a fully formed chunk
      const startIndex = buffer.indexOf(startByte);
      if (startIndex === -1) {
        break;
      }
      const endIndex = buffer.indexOf(endByte);
      if (endIndex === -1) {
         break;
      }


      // startIndex is one index before the start of the actual data
      const messageBytes = buffer.slice(startIndex + 1, endIndex);
      const messageText: string = new TextDecoder().decode(messageBytes)

      try {
        const snapshot = JSON.parse(messageText);
        yield snapshot;
      } catch (e) {
        console.error("Failed to parse", messageText);
      }

      // remove the processed fully formed message from the buffer
      // this will be everything including the last end magic byte
      buffer = buffer.slice(endIndex + 1);
    }
    if (done) {
      break;
    }
  }
}

export function isMessagePositionIndicator(obj: unknown): obj is StreamingResponseMessagePosition {
  // Returns true if the streaming response contains info about the position we're at in the full response
  return (
      typeof obj === 'object' && obj !== null && 'message_position' in obj
  );
}

export function isStreamingResponseErrorDetail(obj: unknown): obj is StreamingResponseErrorDetail {
  // Returns true if the streaming response is an error detail or not
  return (
      typeof obj === 'object' && obj !== null && 'exception' in obj && 'traceback' in obj
  );
}

export function isBacktestResultDetail(obj: unknown): obj is TradingBacktestResult {
  // Returns true if the streaming response is a backtest result or not
  return (
      typeof obj === 'object' && obj !== null && 'summary' in obj && 'trailing_stats' in obj && 'printout' in obj && 'trade_history' in obj
  );
}


export async function* backtestTradingAlgorithm(
    props: TradingAlgorithmBacktestRequest): AsyncGenerator<
    TradingAlgorithmBacktestStreamingResponse |
    TradingBacktestResult |
    StreamingResponseErrorDetail |
    StreamingResponseMessagePosition,
    void,
    unknown> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/backtest'
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  if (response.ok) {
    for await (const jsonResponse of parseStreamedResponse(response)) {
      if (isStreamingResponseErrorDetail(jsonResponse)) {
        yield jsonResponse as StreamingResponseErrorDetail;
      } else if (isMessagePositionIndicator(jsonResponse)) {
        console.log("We are at position", jsonResponse.message_position)
        yield jsonResponse as StreamingResponseMessagePosition;
      } else if (isBacktestResultDetail(jsonResponse)) {
        yield jsonResponse as TradingBacktestResult;
      }
      else {
        yield jsonResponse as TradingAlgorithmBacktestStreamingResponse;
      }
    }

  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }

}

export async function getTradingAlgos(props: GetTradingAlgosRequest): Promise<GetTradingAlgosResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/algos'
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  if (response.ok) {
    const data = await response.json();
    console.debug(data);
    return data as GetTradingAlgosResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function putTradingAlgo(props: PutTradingAlgosRequest): Promise<PutTradingAlgosResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/algo';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as PutTradingAlgosResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function deleteTradingAlgo(props: DeleteTradingAlgoRequest): Promise<DeleteTradingAlgoResponse>{
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/algo';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as DeleteTradingAlgoResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}


export async function verifyEmail(props: EmailVerificationRequest): Promise<EmailVerificationResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/email/verify';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as EmailVerificationResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function passwordResetRequest(props: PasswordResetRequest): Promise<PasswordResetResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/email/passwordreset';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as PasswordResetResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function passwordResetVerifiedRequest(props: PasswordResetRequest): Promise<PasswordResetResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/email/passwordresetverified';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as PasswordResetResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function createStripeCustomerAccount(props: StripeCreateCustomerRequest): Promise<StripeCreateCustomerResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/payments/v1/customer';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as StripeCreateCustomerResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function createStripeCheckoutSession(props: StripeCreateCheckoutSessionRequest): Promise<StripeCreateCheckoutSessionResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/payments/v1/checkout';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as StripeCreateCheckoutSessionResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function cancelAllStripeSubscriptions(props: StripeCancelSubscriptionsRequest): Promise<StripeCancelSubscriptionsResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/payments/v1/subscriptions/cancelall';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as StripeCancelSubscriptionsResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function deleteAccount(props: DeleteAccountRequest): Promise<DeleteAccountResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/auth/v1/account/delete';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as DeleteAccountResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}
export async function saveBacktestResult(props: StorableBacktestResultRequest): Promise<StorableBacktestResultResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/v1/save/backtest';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as StorableBacktestResultResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}


export async function getBacktestHistory(props: GetBacktestHistoryRequest): Promise<GetBacktestHistoryResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/v1/backtests/history';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    // Handle objects requiring Date objects, since they won't be parsed automatically
    return {
    ...data,
        backtests: data.backtests.map((backtest: any) => ({
      ...backtest,
      backtest_start_date: new Date(backtest.backtest_start_date),
      backtest_end_date: new Date(backtest.backtest_end_date),
    })),
    } as GetBacktestHistoryResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function submitTradingFeedback(props: TradingFeedbackRequest): Promise<TradingFeedbackResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/v1/feedback';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as TradingFeedbackResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function shareBacktestResult(props: CreateShareableBacktestLinkRequest): Promise<CreateShareableBacktestLinkResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/v1/backtest/share';
  console.debug('Request URL:', url);
  console.debug('Request body:', JSON.stringify(props));

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  console.debug(JSON.stringify(response));

  if (response.ok) {
    const data = await response.json();
    return data as CreateShareableBacktestLinkResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export async function getSharedBacktest(props: GetSharedBacktestRequest): Promise<GetSharedBacktestResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + `/trading/v1/backtest/shared/${encodeURIComponent(props.backtest_unique_id)}`;
  console.debug('Request URL:', url);

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.ok) {
    const data = await response.json();
    // Convert date strings to Date objects when present.
    if (data?.backtest) {
      data.backtest = {
        ...data.backtest,
        backtest_start_date: data.backtest.backtest_start_date
          ? new Date(data.backtest.backtest_start_date)
          : data.backtest.backtest_start_date,
        backtest_end_date: data.backtest.backtest_end_date
          ? new Date(data.backtest.backtest_end_date)
          : data.backtest.backtest_end_date,
      };
    }
    return data as GetSharedBacktestResponse;
  } else if (response.status === 404) {
    return {
      success: false,
      detail: 'This shared backtest link is invalid or has expired.',
    } as GetSharedBacktestResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}


export async function getPriceForTickerOnDate(props: GetPriceForTickerOnDateRequest): Promise<GetPriceForTickerOnDateResponse> {
  const hostname = getJunkyardAPIHostname();
  const url = hostname + '/trading/ticker/price'
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(props),
  });
  if (response.ok) {
    const data = await response.json();
    console.debug(data);
    return data as GetPriceForTickerOnDateResponse;
  } else {
    throw new Error(`HTTP error! status: ${response.statusText}: ${await response.text()}`);
  }
}

export const streamChat = async (
    props: StreamChatRequest
): Promise<void> => {
  const hostname = getJunkyardAPIHostname();

  const messages = props.messages;
  const onError = props.onError;
  const onDelta = props.onDelta;
  const coreRequest = props as StreamChatRequestCore;

  const res = await fetch(`${hostname}/chat/completions`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(props),
  });
  if (!res.ok || !res.body) {
    onError(`Request failed (${res.status})`);
    return;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const {done, value} = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, {stream: true});
    const events = buffer.split('\n\n');
    buffer = events.pop() ?? '';
    for (const event of events) {
      const payload = event.replace(/^data: /, '').trim();
      if (!payload || payload === '[DONE]') continue;
      const parsed = JSON.parse(payload);
      if (parsed.error) onError(parsed.error);
      else if (parsed.delta) onDelta(parsed.delta);
    }
  }
};

